import Vue from 'vue';
import {PostParams} from '@/models/params/postParams';
import { StoreObjectList } from '@/store/storeObject';
import { Post } from '@/models/dtos';

export default Vue.extend({
	props: {
		disableLoader: {
			type: Boolean,
			default: false,
		},
		/**
		 * The post template Id, like product=13
		 */
		postTemplateId: {
			type: Number,
			required: true,
		},
		/**
		 * The number of posts it is limited to
		 */
		limit: {
			type: Number,
			required: false,
			default: 100,
		},
	},
	data() {
		return {
			params: {
				postTemplateId: this.postTemplateId,
				limit: this.limit,
				offset: 0,
			} as PostParams,
		};
	},
	async created() {
		await this.$store.dispatch('loadPosts', this.params);
	},
	computed: {
		posts(): StoreObjectList<Post> {
			return this.$store.getters.postsByParams(this.params);
		},
	},
});
